import React, { useRef } from 'react';
import Slider from 'react-slick';
import TrustedCard from './TrustedCard';
import 'slick-carousel/slick/slick.css';

import { ArrowButton } from '../../../ui';

function SampleNextArrow(props) {
  const { onClick } = props;

  return (
    <ArrowButton
      className="shadow-[0px_4px_7.1px_0px_rgba(0,0,0,0.17)] right-0 absolute top-[50%] translate-y-[-50%] bg-[#979797] text-white"
      shape="circle"
      direction="right"
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;

  return (
    <ArrowButton
      className="shadow-[0px_4px_7.1px_0px_rgba(0,0,0,0.17)] left-0 absolute top-[50%] translate-y-[-50%] bg-[#979797] text-white"
      shape="circle"
      direction="left"
      onClick={onClick}
    />
  );
}

const TrustedSlider = () => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
    ],
  };
  return (
    <div className="flex flex-col md:gap-[63px] gap-[48px]">
      <style>
        {`
          .slick-list {
            overflow: hidden;  
          }
          .slick-track {
            display: flex;
            align-items: center;  
          }
          .slick-slide {
            outline: none;
          }
          .slick-slide div {
            outline: none;
          }
          .custom-dots {
            display: flex !important;
            justify-content: center;
          }
          .custom-dots li {
            position: relative;
            margin: 0 3px;
            margin-top: 20px;
            width: 50px;
            height: 2px;
            background-color: #C4C4C4;
            overflow: hidden;
          }
          .trusted-slider .custom-dots li.slick-active{
            background-color:#D9A8E5;
          }
          .custom-dots li button {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }  
        `}
      </style>
      <h2 className="flex justify-start md:justify-center items-center font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black">
        Testimonials
      </h2>

      <Slider ref={slider} {...settings} className={'trusted-slider z-10 lg:max-w-[580px] w-full leading-[15px] lg:px-[40px]'}>
        <div className="pr-[30px] md:pr-[24px] md:pl-[24px]">
          <TrustedCard
            header="Their team is incredibly professional and knowledgeable"
            content="The efforts of Prodigi have been producing the intended results. They continue to communicate effectively, providing constant updates and support regarding the progress of your SEO. Their strong adherence to quality allows them to meet our high standards."
            reviewImgUrl="https://weprodigi.com/uploads/images/home-page/review2.png"
            revierCompany="Head, Bentley Yerevan"
            revierInfo="Mariam Matnishyan"
          />
        </div>
        <div className="pr-[30px] md:pr-[24px] md:pl-[24px]">
          <TrustedCard
            header="Their clear and thorough communication throughout the project, especially regarding the SEO services focus, was impressive"
            content="I found most impressive about Prodigi their attention to details, their creativity and passion for the project, their ability to work to tight schedules and meet deadlines, their ability to think outside the box especially during the COVID-19 restrictions."
            reviewImgUrl="https://weprodigi.com/uploads/images/home-page/review4.png"
            revierCompany="Director, SelectTvFormats LTD"
            revierInfo="Johnson Samuyiwa"
          />
        </div>
      </Slider>
    </div>
  );
};

export default TrustedSlider;
